import { render, staticRenderFns } from "./MandateEmailModal.vue?vue&type=template&id=3c0f4a89&scoped=true&"
import script from "./MandateEmailModal.vue?vue&type=script&lang=js&"
export * from "./MandateEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./MandateEmailModal.vue?vue&type=style&index=0&id=3c0f4a89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0f4a89",
  null
  
)

export default component.exports